import React,{useContext, useEffect} from 'react';
import LeftSitebarMenu from '../../components/leftSitebarMenu/LeftSitebarMenu';
import RightSitebarMenu from '../../components/rightSitebarMenu/RightSitebarMenu';
import MainMenu from './../../components/mainMenu/MainMenu';
import FilterAndShort from './../../components/filterAndShort/FilterAndShort';
import BlogPosts from './blogPosts/BlogPosts';
import clipIcon from '../../assets/img/forum-imgs/new-discussion-icon.svg';
import closerIcon from '../../assets/img/feed-imgs/navbar/closeicon.svg';
import { ShowHideSitebar } from './../../App';

const Blogs = () => {
    const [showHideSidebar, setShowHideSidebar] = useContext(ShowHideSitebar)
    useEffect(()=>{ /** setting the page name for the sidebars of this page to work */
        const setPageName = {...showHideSidebar}
        setPageName.pageName = 'home';
        setPageName.home.left = false;
        setPageName.home.right = false;
        setShowHideSidebar(setPageName)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const closeSidebar =(whichSidebar, status)=>{
        const newStatus = {...showHideSidebar}
        if(whichSidebar === 'left'){
            newStatus.home.left = status /** changing the page name for left sidebar to toggle */
            setShowHideSidebar(newStatus) /** changing the page name for right sidebar to toggle */
        }
        if(whichSidebar === 'right'){
            newStatus.home.right = status
            setShowHideSidebar(newStatus)
        }
    }
    return (
        <>
            {/* Main Menu / Main Navbar */}
            <MainMenu></MainMenu>
            {/* Menu bar start here */}
            <div className="container-fluid container-lg">
                <div className="row gap-5 gap-lg-0">
                    {/* Left Site Bar Start here */}
                    <div className={`col-12 col-lg-2  d-lg-block ${showHideSidebar?.home?.left ? 'd-block right-sitebarmenu' : 'd-none'}`}>
                    <div className="d-flex d-lg-none justify-content-end mb-3">
                        <div onClick={()=>closeSidebar("left", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                <img src={closerIcon} alt="" className='close-menu-button' />
                            </div>
                        </div>
                        <LeftSitebarMenu></LeftSitebarMenu>
                    </div>    
                    {/* Center Menu */}
                    <div className="col-12 col-lg-6">
                        {/* Filter and Search Page here  Also Create a Blog part*/}
                        <div className="row mb-5 gap-2 gap-lg-0 p-0">
                            <div className="col-12 col-lg-8 col-md-6">
                                <button className="custm-pill-button-small rounded-pill px-3 py-2 post_btn d-flex align-items-center" type="button"><img src={clipIcon} alt="" className='me-3' /> Create a Blog</button>               
                            </div>
                            <div className="col-6 col-lg-4 col-md-5 d-flex justify-content-around  align-items-start">
                                <FilterAndShort></FilterAndShort>
                            </div>
                        </div>
                        {/* Show All Blog Post Here */}
                        <BlogPosts></BlogPosts>
                        
                    </div>
                    {/* Right Site Bar Menu */}
                    <div className={`col-12 col-lg-4  d-lg-block ${showHideSidebar?.home?.right ? 'd-block right-sitebarmenu' : 'd-none'}`}>
                         <div className="d-flex d-lg-none justify-content-end mb-3">
                            <div onClick={()=>closeSidebar("right", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                <img src={closerIcon} alt="" className='close-menu-button' />
                            </div>
                        </div>
                        <RightSitebarMenu />
                    </div>   
                </div>
            </div>
        </> 
    );
};

export default Blogs;